require('./angular/app.js');
require('./angular/controllers/PitchPitchLandingCtrl.js');


// WEBPACK FOOTER //
// ./src/PlaylistPitchClientBundle/Resources/js/index.js